import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  Renderer2,
  ViewChild,
  OnChanges,
  OnDestroy,
} from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import * as FileSaver from "file-saver";
import { VerifyClientList } from "../../../../core/models/client/verify/verifyClientList";
import { ClientList } from "../../../../core/models/client/clientList";
import { DashbaordPocAdditionalFilters } from "../../../../core/models/common/dashboardPocAdditionalFilters.dto";
import { LoaderService } from "../../../../core/services/loader.service";
import { SidebarService } from "../../../../core/services/sidebar.service";
import { SharedService } from "../../../../core/services/shared.service";
import { Table, TableFilterEvent, TableModule } from "primeng/table";
import { CommonModule } from "@angular/common";
import { DateFilterComponent } from "../../../../shared/components/date-filter/date-filter.component";
import { CheckboxModule } from "primeng/checkbox";
import { FormsModule } from "@angular/forms";
import { ModalStackerComponent } from "../../../../shared/components/modal-stacker/modal-stacker.component";
import { ClientDetailsComponent } from "../client-details/client-details.component";
import { ClientsListingService } from "../../../../core/services/clients-listing.service";
import { DateFilter } from "../../../../core/models/common/date-filter-request.dto";
import { GenericResponseDto } from "../../../../core/models/generic-response.dto";

@UntilDestroy()
@Component({
  selector: "jni-clients-listing-inactive",
  templateUrl: "./clients-listing-inactive.component.html",
  imports: [
    TableModule,
    CommonModule,
    DateFilterComponent,
    CheckboxModule,
    FormsModule,
    ModalStackerComponent,
    ClientDetailsComponent,
  ],
  styleUrls: ["./clients-listing-inactive.component.scss"],
})
export class ClientsListingInactiveComponent
  implements OnInit, OnChanges, OnDestroy
{
  @ViewChild("dt") table!: Table;
  @Input() expiringDayFromModal = "";
  @Input() clientStatus = "";
  @Output() scrollHiddenStatus = new EventEmitter();

  clientListings: VerifyClientList[] = [];
  filterClientList: VerifyClientList[] = [];
  filterClientListExport: VerifyClientList[] = [];
  checkboxStatus = 0;
  selectedClients: ClientList[] = [];
  expiringDays = "";
  heading = "Clients";
  newHeading = "In Active Client List";
  showSmallLoader = false;
  clientDisplayModal = false;
  clientDisplayModalStatus = false;
  clientId = "";
  organizationNameCharacterCond = false;
  lastOrderDateColumn = "lastOrderDate";
  lastOrderDateFilterApplied = false;
  descriptionCharacterCond = false;
  dashbaordPocAdditionalFilters: DashbaordPocAdditionalFilters =
    {} as DashbaordPocAdditionalFilters;
  constructor(
    public router: ActivatedRoute,
    public route: Router,
    public _loaderService: LoaderService,
    public _clientsListingService: ClientsListingService,
    private renderer: Renderer2,
    private _sidebarService: SidebarService,
    private _sharedService: SharedService
  ) {
    this.router.params.subscribe((params: Params) => {
      this.clientStatus = params["id"];
      this.expiringDays = params["type"];
      if (typeof this.expiringDays === "string") {
        this.newHeading = "";
        this.newHeading = `${this.heading} with 30 days or less protection remaining`;
      }
      this.closeModalOnClient();
    });
  }

  ngOnInit() {
    this.getClientData();
    this.clearAndSetSimpleOrderSearchResponseObj();
    this._sharedService.setOrderSearchValue("");
    this._sharedService.setOrderSearchPlaceholderValue("Search");
  }

  clearAndSetSimpleOrderSearchResponseObj() {
    const orderSearch: string[] = [];
    this._sharedService.setSimpleOrderSearchResponseObject(orderSearch);
  }

  closeModalOnClient() {
    // this._sidebarService.selectedMenu$.subscribe((value) => {
    //   if (value && value?.includes('clients')) {
    //     this.clientDisplayModal = false;
    //   }
    // });
  }

  ngOnChanges() {
    if (this.expiringDayFromModal) {
      this.expiringDays = this.expiringDayFromModal;
      if (typeof this.expiringDays === "string") {
        this.newHeading = "";
        this.newHeading = `${this.heading} with 30 days or less protection remaining`;
      }
      this.clientDisplayModalStatus = true;
      //this.ngOnInit();
    }
  }

  onClientRedirection() {
    const url = `/clients/active/verify-client`;
    this.route.navigate([url]);
  }

  closeModalForClient() {
    this.clientDisplayModal = false;
  }

  checkboxSelection() {
    const count = this.clientListings.filter(
      obj => obj.isActive == true
    ).length;
    if (count > 1 || count == 0) {
      this._clientsListingService.setAttachmentState(true);
    } else {
      this._clientsListingService.setAttachmentState(false);
    }
  }

  getClientData() {
    if (this.clientStatus) {
      if (this.expiringDays) {
        this.getClientListUnprotectedDays();
      } else {
        this.getClientListData();
      }
    }
  }

  getClientListData() {
    this._loaderService.setLoaderState(true);
    this._clientsListingService
      .GetAllInActiveClientsList("Submitted")
      .pipe(untilDestroyed(this))
      .subscribe({
        next: (res: GenericResponseDto<VerifyClientList[]>) => {
          this.clientListings = res.data;
          this.filterClientList = this.clientListings;
          this._loaderService.setLoaderState(false);
        },
        error: () => {
          this._loaderService.setLoaderState(false);
        },
      });
  }

  getClientListUnprotectedDays() {
    this._loaderService.setLoaderState(true);
    this.showSmallLoader = true;
    this._clientsListingService
      .getClientListUnprotectedDays("Submitted", "0")
      .pipe(untilDestroyed(this))
      .subscribe({
        next: (res: GenericResponseDto<VerifyClientList[]>) => {
          this.clientListings = res.data;
          this.filterClientList = this.clientListings;
          this._loaderService.setLoaderState(false);
          this.showSmallLoader = false;
        },
        error: () => {
          this._loaderService.setLoaderState(false);
          this.showSmallLoader = false;
        },
      });
  }

  redirectToSummaryPage(accountNumber: string) {
    if (accountNumber) {
      this.clientId = accountNumber;
      this.clientDisplayModal = true;
    }
    // const url =
    //   `/clients/${this.clientStatus}/client-details/` +
    //   accountNumber.toString();
    // this.route.navigate([url]);
  }

  exportExcel() {
    // this.showSmallLoader = true;
    // this.filterClientList.length = 0;
    // this.clientListings.forEach((ele) => {
    //   if (ele.isActive) {
    //     this.checkboxStatus = 1;
    //     this.filterClientList.push(ele);
    //   }
    // });
    // if (this.checkboxStatus == 1) {
    //   this.exportExcelForFilterData(this.filterClientList);
    //   this.showSmallLoader = false;
    // } else {
    //   this.exportExcelForFilterData(this.clientListings);
    //   this.showSmallLoader = false;
    // }
    this.showSmallLoader = true;
    this.exportExcelForFilterData(this.filterClientListExport);
    this.showSmallLoader = false;
  }

  exportExcelForFilterData(filterclientlist: VerifyClientList[]) {
    const object = filterclientlist.map(datum => {
      return {
        ["Account"]: datum.customerAccount,
        ["Name"]: datum.organizationNameD365,
        ["Available Credit"]: datum.availableCredit,
        ["Address"]: datum.clientPrimaryAddress,
        ["Contact"]: datum.primaryContactName,
        ["Branding Consultant"]: datum.brandingconsultant,
        ["Safe Days"]: datum.protectionNumber,
        ["Billing Rep"]: datum.billingRepD365,
        ["Last Order"]: datum.lastOrderDate,
        // ['Email']: datum.primaryContactEmail,
        // ['Contact Number']: datum.primaryContactNumber,
      };
    });

    import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet(object);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: ArrayBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      this.saveAsExcelFile(excelBuffer, "ClientList");
    });
  }

  saveAsExcelFile(buffer: ArrayBuffer, fileName: string): void {
    const EXCEL_TYPE =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const EXCEL_EXTENSION = ".xlsx";
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE,
    });
    FileSaver.saveAs(
      data,
      fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
    );
  }

  addScollHiddenClass() {
    if (this.clientDisplayModalStatus) {
      this.renderer.addClass(document.body, "p-overflow-hidden");
    } else {
      this.renderer.removeClass(document.body, "p-overflow-hidden");
    }
  }

  ngOnDestroy(): void {
    this.scrollHiddenStatus.emit();
  }

  redirectToOrderListingPage(accountNumber: string) {
    if (accountNumber) {
      const objData = this.setOrdersAdditionalFilters(accountNumber);
      objData.status = "ALL";
      this._sharedService.setDashbaordPocAdditionalFiltersObject(objData);
      this.route.navigate(["orders/orderslist/1"]);
    }
  }

  setOrdersAdditionalFilters(accountNumber: string) {
    const dashbaordPocAdditionalFilters: DashbaordPocAdditionalFilters = {
      customerAccountNumber: accountNumber,
      additionalFilters: true,
    } as DashbaordPocAdditionalFilters;
    return dashbaordPocAdditionalFilters;
  }

  organizationNameCharacterCount(obj: string) {
    if (obj && obj?.length > 40) this.organizationNameCharacterCond = true;
  }

  clearFilter(event: VerifyClientList[] | DateFilter) {
    if (Array.isArray(event)) {
      this.filterClientList = event;
      this.filterClientListExport = this.filterClientList;
      this.lastOrderDateFilterApplied = false;
    }
  }

  applyFilter(event: VerifyClientList[] | DateFilter) {
    if (Array.isArray(event)) {
      this.filterClientList = event;
      this.filterClientListExport = this.filterClientList;
      this.lastOrderDateFilterApplied = true;
    }
  }

  onFilter(event: TableFilterEvent) {
    if (event.filters) {
      this.filterClientListExport = event.filteredValue;
    } else if (!this.lastOrderDateFilterApplied) {
      this.filterClientListExport = this.clientListings;
    }
  }

  descriptionCharacterCount(obj: string) {
    if (obj) {
      if (obj.length > 45) this.descriptionCharacterCond = true;
    }
  }
}
